import { goSolidApi } from "@/composables/useGoSolidApi";
import type { BeneficiaryTypeEnum } from "@/types";

/**
 * @property beneficiary_type - Null when this beneficiary's history records no type (statements
 * stored before the field existed).
 * @property registry_country_region - A region the cancel form's dropdown can offer (a supported
 * registry, or the "Any AIB" sentinel), or null when this beneficiary's history holds neither.
 */
export interface CancelBeneficiarySuggestion {
  beneficiary_name: string;
  beneficiary_type: BeneficiaryTypeEnum | null;
  registry_code: string | null;
  registry_country_region: string | null;
  address: string | null;
}

interface CancelBeneficiarySuggestionsResponse {
  beneficiaries: CancelBeneficiarySuggestion[];
}

/**
 * Fetches the current company's deduplicated cancellation beneficiary history, most recently used
 * first. The whole list is returned once and filtered client-side.
 */
export const cancelBeneficiariesApi = {
  list: (companyId: number) =>
    goSolidApi.get<CancelBeneficiarySuggestionsResponse>(
      `/api/company/${companyId}/portfolio/cancel/beneficiaries`
    ),
};
